// Trilingual translations for Smart Way International
// ar = Arabic, en = English, ur = Urdu

export const translations = {
  ar: {
    dir: "rtl",
    langLabel: "العربية",
    nav: {
      home: "الرئيسية",
      about: "من نحن",
      services: "خدماتنا",
      individual: "خدمات الأفراد",
      company: "خدمات الشركات",
      followup: "خدمات التعقيب",
      eservices: "الخدمات الإلكترونية",
      foreign: "الاستثمار الأجنبي",
      licensing: "التأسيس والتراخيص",
      contact: "تواصل معنا",
      requestService: "اطلب خدمة",
    },
    brand: {
      name: "سمارت واي إنترناشيونال",
      tag: "مكتب متخصص في خدمات التعقيب والاستثمار",
    },
    home: {
      chapter: "الفصل",
      hero: {
        line1: "الطريق الذكي",
        line2: "لإنجاز أعمالك",
        line3: "بسرعة ودقة وسرية",
        sub: "مكتب متخصص في التعقيب الحكومي وتأسيس الشركات وخدمات الاستثمار الأجنبي في المملكة العربية السعودية.",
        cta1: "اطلب خدمة الآن",
        cta2: "واتساب",
        cta3: "اتصل بنا",
      },
      intro: {
        eyebrow: "٠١ — من نحن",
        title: "نصنع الفرق بدقة الصقر ورؤيته",
        body: "منذ سنوات، ونحن نقود عملاءنا نحو حلول حكومية وإدارية بأعلى معايير الاحتراف. سرعة، سرية، ودقة لا تُساوَم.",
      },
      services: {
        eyebrow: "٠٢ — خدماتنا",
        title: "أربعة محاور. إمكانيات لا نهائية.",
        cards: [
          { t: "خدمات الأفراد", d: "أبشر، نقل الكفالة، الإقامة، التأشيرات وأكثر.", to: "/services/individual" },
          { t: "خدمات الشركات", d: "قوى، الموارد البشرية، بلدي، حماية الأجور.", to: "/services/company" },
          { t: "التعقيب الحكومي", d: "متابعة وإنهاء المعاملات نيابة عن العميل.", to: "/services/follow-up" },
          { t: "الاستثمار الأجنبي", d: "رخص، تأسيس، سجل تجاري وتأشيرات مدير.", to: "/services/foreign-investment" },
        ],
      },
      popular: {
        eyebrow: "٠٣ — الأكثر طلبًا",
        title: "الخدمات التي يثق بها عملاؤنا",
        list: [
          "نقل كفالة العمال",
          "إصدار التأشيرات",
          "خدمات قوى وحماية الأجور",
          "منصة ناجز والتسجيل العيني",
          "رخصة الاستثمار الأجنبي",
          "تأسيس الشركات",
        ],
      },
      why: {
        eyebrow: "٠٤ — لماذا نحن",
        title: "نعمل بمعايير تختلف عن الجميع",
        points: [
          { n: "01", t: "السرعة", d: "دورة إنجاز مضغوطة دون تنازل عن الجودة." },
          { n: "02", t: "السرية", d: "تعاملاتك محفوظة خلف اتفاقيات صارمة." },
          { n: "03", t: "الدقة", d: "مراجعة بشرية دقيقة لكل مستند." },
          { n: "04", t: "المتابعة", d: "تحديثات مباشرة حتى إنهاء المعاملة." },
        ],
      },
      stats: {
        eyebrow: "٠٥ — أرقام تتحدث",
        items: [
          { n: "+٢٥٠٠", l: "معاملة مُنجزة" },
          { n: "+٤٨٠", l: "عميل يثق بنا" },
          { n: "٩٨٪", l: "نسبة النجاح" },
          { n: "٢٤/٧", l: "دعم متواصل" },
        ],
      },
      quickContact: {
        title: "على بُعد رسالة واحدة",
        sub: "نرد خلال دقائق. اختر ما يناسبك:",
      },
      marquee: "التعقيب · الاستثمار · قوى · بلدي · ناجز · التأمينات · التجارة · العقار · التأشيرات · الأبشر · ",
    },
    about: {
      eyebrow: "من نحن",
      title: "شركة استثمارية بنكهة سعودية.",
      body: "سمارت واي إنترناشيونال مكتب متخصص في التعقيب الحكومي وتأسيس الشركات وخدمات الاستثمار الأجنبي. نجمع بين الخبرة القانونية والإدارية والفهم العميق للأنظمة السعودية لنقدّم حلولاً موثوقة للأفراد والشركات والمستثمرين.",
      years: "سنوات من الخبرة",
      yearsN: "+10",
      vision: {
        t: "الرؤية",
        d: "أن نكون الشريك الأول للأفراد والشركات والمستثمرين في إنجاز خدماتهم الحكومية بكفاءة عالية.",
      },
      mission: {
        t: "الرسالة",
        d: "تقديم خدمات تعقيبية واستشارية بمعايير احترافية وسرية تامة تُختصر بها الأوقات وتُصان بها الحقوق.",
      },
      strengths: [
        { t: "السرعة", d: "زمن إنجاز مدروس." },
        { t: "السرية", d: "حماية كاملة للبيانات." },
        { t: "الدقة", d: "صفر أخطاء إن أمكن." },
        { t: "المتابعة", d: "لا نتركك في المنتصف." },
      ],
      audiences: {
        t: "لمن نقدّم خدماتنا",
        items: ["الأفراد", "المنشآت والشركات", "المستثمرون الأجانب"],
      },
    },
    services: {
      eyebrow: "الخدمات",
      title: "خدمات مُصمَّمة حسب احتياجك",
      body: "من الفرد إلى المستثمر الأجنبي، نغطي منظومة الخدمات الحكومية والإلكترونية بالكامل.",
      cards: [
        { t: "خدمات الأفراد", d: "أبشر، الإقامة، التأشيرات، نقل الكفالة، التأمين الطبي.", to: "/services/individual" },
        { t: "خدمات الشركات", d: "قوى، بلدي، حماية الأجور، التأمينات، وزارة التجارة.", to: "/services/company" },
        { t: "خدمات التعقيب", d: "متابعة وإنهاء المعاملات نيابة عن العميل.", to: "/services/follow-up" },
        { t: "الاستثمار الأجنبي", d: "رخص وسجل تجاري وتوثيق عقود وتأشيرات.", to: "/services/foreign-investment" },
        { t: "الخدمات الإلكترونية", d: "ناجز، التسجيل العيني، المياه، الكهرباء، السيارات.", to: "/services/e-services" },
        { t: "التأسيس والتراخيص", d: "تأسيس شركات، تحويل المؤسسة، سجل تجاري.", to: "/services/licensing" },
      ],
    },
    individual: {
      title: "خدمات الأفراد",
      body: "خدمات مباشرة لكل ما يخصك الشخصي أمام الجهات الحكومية.",
      items: [
        "خدمات أبشر",
        "نقل كفالة العمال",
        "طباعة الإقامة",
        "إصدار التأشيرات",
        "إلغاء بلاغ الهروب",
        "تأمين طبي",
      ],
    },
    company: {
      title: "خدمات الشركات",
      body: "شريكك الإداري لكل ما تحتاجه منشأتك من خدمات حكومية ورقمية.",
      items: [
        "خدمات الموارد البشرية",
        "خدمات قوى",
        "خدمات حماية الأجور",
        "خدمات منصة بلدي",
        "خدمات التأمينات الاجتماعية",
        "خدمات وزارة التجارة",
        "نقل ملكية السجل التجاري مع العمال",
        "تحويل المؤسسة إلى شركة",
        "تأسيس الشركات الفردية والاستثمار",
      ],
    },
    followup: {
      title: "خدمات التعقيب",
      body: "نُنجز عنك. باحترافية، بسرية، وبسرعة.",
      items: [
        "متابعة وإنهاء المعاملات الحكومية",
        "إنهاء الإجراءات نيابة عن العميل",
        "رفع ومتابعة الطلبات",
        "مراجعة الجهات الرسمية",
        "ترتيب المستندات والتصاريح",
        "خدمة سرية وسريعة واحترافية",
      ],
    },
    eservices: {
      title: "الخدمات الإلكترونية",
      body: "كل ما يخص المنصات الرقمية الحكومية في مكان واحد.",
      items: [
        "التسجيل العيني للعقار",
        "خدمات منصة ناجز",
        "تأمين سيارات",
        "نقل ملكية السيارة",
        "كافة معاملات شركة الكهرباء",
        "كافة معاملات شركة المياه",
        "كافة الشهادات الحكومية",
        "فتح الملفات الحكومية",
        "تحديث البيانات",
        "إصدار وثائق أو شهادات إلكترونية",
        "متابعة الطلبات عبر المنصات",
        "الخدمات المرتبطة بالمنصات الحكومية المختلفة",
      ],
    },
    licensing: {
      title: "التأسيس والتراخيص",
      body: "من الفكرة إلى بدء النشاط. نُهيّئ لك البنية القانونية والإدارية الكاملة.",
      items: [
        "تأسيس الشركات الفردية",
        "تحويل المؤسسة إلى شركة",
        "استخراج السجل التجاري",
        "توثيق العقود",
        "إعداد الملفات القانونية",
        "بدء النشاط بشكل نظامي",
      ],
    },
    foreign: {
      eyebrow: "الاستثمار الأجنبي",
      title: "بوابتك إلى الاقتصاد السعودي.",
      body: "نُقدّم للمستثمرين الأجانب حزمة متكاملة لتأسيس ورخص واستخراج السجل التجاري وتأشيرة المدير العام.",
      why: {
        t: "لماذا الاستثمار في السعودية؟",
        points: [
          "اقتصاد ضمن أكبر ٢٠ اقتصادًا عالميًا.",
          "رؤية ٢٠٣٠ وحوافز استثمارية غير مسبوقة.",
          "قطاعات مفتوحة للأجانب بنسبة تملّك ١٠٠٪.",
          "بنية تحتية متقدمة وموقع استراتيجي.",
        ],
      },
      offering: {
        t: "ما نقدّمه للمستثمر الأجنبي",
        items: [
          "إصدار رخصة الاستثمار الأجنبي",
          "توثيق عقد تأسيس الشركة",
          "استخراج السجل التجاري",
          "تجهيز الملفات الحكومية",
          "إصدار تأشيرة المدير العام",
          "إعداد النظام الأساسي والهيكل الإداري",
        ],
      },
      steps: {
        t: "خطوات إصدار الترخيص",
        items: [
          { n: "01", t: "الاستشارة", d: "جلسة تعريفية وتحديد النشاط." },
          { n: "02", t: "المستندات", d: "تجهيز الوثائق والترجمة القانونية." },
          { n: "03", t: "التقديم", d: "رفع الطلب أمام وزارة الاستثمار." },
          { n: "04", t: "الترخيص", d: "استلام الرخصة والسجل التجاري." },
          { n: "05", t: "التشغيل", d: "التأشيرات وفتح الملفات وبدء النشاط." },
        ],
      },
      docs: {
        t: "المستندات المطلوبة",
        items: [
          "السجل التجاري للشركة الأم مصدّق.",
          "القوائم المالية لآخر سنة مصدّقة.",
          "قرار مجلس الإدارة بالاستثمار في السعودية.",
          "جوازات سفر المديرين والمساهمين.",
          "وكالة قانونية للمكتب.",
        ],
      },
      duration: {
        t: "المدة المتوقعة",
        d: "غالبًا بين ٥ إلى ١٥ يوم عمل حسب النشاط ونوع الرخصة.",
      },
      faq: {
        t: "أسئلة شائعة",
        items: [
          { q: "هل يمكنني التملّك ١٠٠٪؟", a: "نعم، في أغلب الأنشطة يُسمح للمستثمر الأجنبي بالتملّك الكامل." },
          { q: "هل الحضور شخصيًا مطلوب؟", a: "لا. يمكن تسيير كامل الإجراءات عبر وكالة قانونية معتمدة." },
          { q: "كم تكلفة الترخيص؟", a: "تختلف حسب النشاط والرأس المال؛ نُقدّم عرضًا مفصّلًا بعد الاستشارة." },
          { q: "هل تشمل الخدمة تأشيرة المدير؟", a: "نعم، نُصدر تأشيرة المدير العام ضمن الحزمة." },
        ],
      },
      cta: "ابدأ الآن — اطلب استشارة",
    },
    contact: {
      eyebrow: "تواصل معنا",
      title: "دعنا نبدأ. راسلنا الآن.",
      body: "نموذج طلب خدمة سريع. سنعاود التواصل خلال دقائق.",
      form: {
        name: "الاسم الكامل",
        phone: "رقم الجوال",
        email: "البريد الإلكتروني (اختياري)",
        service: "الخدمة المطلوبة",
        message: "تفاصيل الطلب",
        submit: "إرسال الطلب",
        selectService: "اختر خدمة",
        success: "تم إرسال طلبك بنجاح. سنعاود التواصل معك قريبًا.",
        error: "حدث خطأ. حاول مجددًا.",
      },
      channels: {
        phone: "الهاتف",
        whatsapp: "واتساب",
        email: "البريد الإلكتروني",
      },
    },
    footer: {
      about: "مكتب سمارت واي إنترناشيونال — التعقيب الحكومي وتأسيس الشركات وخدمات الاستثمار الأجنبي.",
      quickLinks: "روابط سريعة",
      contact: "تواصل",
      rights: "جميع حقوق التصميم لعدسة الفن ٢٠٢٦م",
      allRights: "جميع الحقوق محفوظة",
    },
    admin: {
      title: "لوحة الطلبات",
      tokenLabel: "رمز المدير",
      login: "دخول",
      empty: "لا توجد طلبات بعد.",
      status: { new: "جديد", in_progress: "قيد التنفيذ", done: "منجز", archived: "مؤرشف" },
      logout: "خروج",
    },
  },

  en: {
    dir: "ltr",
    langLabel: "English",
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      individual: "Individuals",
      company: "Companies",
      followup: "Follow-up",
      eservices: "E-Services",
      foreign: "Foreign Investment",
      licensing: "Licensing",
      contact: "Contact",
      requestService: "Request a Service",
    },
    brand: {
      name: "Smart Way International",
      tag: "Government relations, incorporation & foreign investment.",
    },
    home: {
      chapter: "Chapter",
      hero: {
        line1: "The smart way",
        line2: "to get things done",
        line3: "with speed, precision & discretion.",
        sub: "A Saudi-based agency specialised in government follow-up, company formation, and foreign investment services.",
        cta1: "Request a service",
        cta2: "WhatsApp",
        cta3: "Call us",
      },
      intro: {
        eyebrow: "01 — Who we are",
        title: "We move with the eye of a falcon.",
        body: "For years we have guided clients through Saudi government and administrative procedures with uncompromising precision, discretion, and speed.",
      },
      services: {
        eyebrow: "02 — What we do",
        title: "Four pillars. Endless possibilities.",
        cards: [
          { t: "Individuals", d: "Absher, sponsorship transfer, Iqama, visas & more.", to: "/services/individual" },
          { t: "Companies", d: "Qiwa, HR, Balady, Wage Protection & GOSI.", to: "/services/company" },
          { t: "Follow-up", d: "We finalise government transactions on your behalf.", to: "/services/follow-up" },
          { t: "Foreign Investment", d: "Licenses, CR, incorporation & GM visas.", to: "/services/foreign-investment" },
        ],
      },
      popular: {
        eyebrow: "03 — Most requested",
        title: "Services our clients trust us with",
        list: [
          "Worker sponsorship transfer",
          "Visa issuance",
          "Qiwa & Wage Protection",
          "Najiz & real-estate registration",
          "Foreign investment license",
          "Company formation",
        ],
      },
      why: {
        eyebrow: "04 — Why us",
        title: "We operate on a different standard.",
        points: [
          { n: "01", t: "Speed", d: "Compressed turnaround with zero shortcuts." },
          { n: "02", t: "Discretion", d: "Your case protected by strict confidentiality." },
          { n: "03", t: "Precision", d: "Human review on every document." },
          { n: "04", t: "Follow-through", d: "Real-time updates until closure." },
        ],
      },
      stats: {
        eyebrow: "05 — Numbers that speak",
        items: [
          { n: "+2,500", l: "Cases delivered" },
          { n: "+480", l: "Clients trust us" },
          { n: "98%", l: "Success rate" },
          { n: "24/7", l: "Continuous support" },
        ],
      },
      quickContact: {
        title: "One message away.",
        sub: "We reply within minutes. Pick your channel:",
      },
      marquee: "Follow-up · Investment · Qiwa · Balady · Najiz · GOSI · MoC · Real-estate · Visas · Absher · ",
    },
    about: {
      eyebrow: "About",
      title: "An investment agency with a Saudi flavour.",
      body: "Smart Way International is a specialised agency for government follow-up, company formation, and foreign investment. We combine legal, administrative, and regulatory expertise to deliver trusted outcomes for individuals, corporates, and investors.",
      years: "Years of experience",
      yearsN: "+10",
      vision: {
        t: "Vision",
        d: "To be the first partner of individuals, corporates, and investors in delivering government services with high efficiency.",
      },
      mission: {
        t: "Mission",
        d: "Provide follow-up and advisory services with professional standards and complete confidentiality — saving time and safeguarding rights.",
      },
      strengths: [
        { t: "Speed", d: "Purposeful turnaround." },
        { t: "Discretion", d: "Complete data protection." },
        { t: "Precision", d: "Zero-error mindset." },
        { t: "Follow-through", d: "We never leave you midway." },
      ],
      audiences: {
        t: "Who we serve",
        items: ["Individuals", "Establishments & companies", "Foreign investors"],
      },
    },
    services: {
      eyebrow: "Services",
      title: "Services tailored to your need.",
      body: "From individual to foreign investor, we cover the full spectrum of Saudi government and digital services.",
      cards: [
        { t: "Individuals", d: "Absher, Iqama, visas, sponsorship, medical insurance.", to: "/services/individual" },
        { t: "Companies", d: "Qiwa, Balady, Wage Protection, GOSI, MoC.", to: "/services/company" },
        { t: "Follow-up", d: "We finalise government transactions on your behalf.", to: "/services/follow-up" },
        { t: "Foreign Investment", d: "Licenses, CR, contract authentication, visas.", to: "/services/foreign-investment" },
        { t: "E-Services", d: "Najiz, RER, water, electricity, vehicles.", to: "/services/e-services" },
        { t: "Licensing", d: "Company formation, conversions, CR.", to: "/services/licensing" },
      ],
    },
    individual: {
      title: "Individual Services",
      body: "Direct services for everything personal with government entities.",
      items: [
        "Absher services",
        "Worker sponsorship transfer",
        "Iqama printing",
        "Visa issuance",
        "Cancelling absconding report",
        "Medical insurance",
      ],
    },
    company: {
      title: "Company Services",
      body: "Your administrative partner for every government and digital need.",
      items: [
        "HR services",
        "Qiwa services",
        "Wage Protection services",
        "Balady platform services",
        "GOSI services",
        "Ministry of Commerce services",
        "CR ownership transfer with workers",
        "Establishment-to-company conversion",
        "Sole proprietorship & investment incorporation",
      ],
    },
    followup: {
      title: "Follow-up Services",
      body: "We handle it — professionally, discreetly, quickly.",
      items: [
        "Following & finalising government transactions",
        "Completing procedures on your behalf",
        "Submitting & tracking applications",
        "Visits to official entities",
        "Arranging documents & permits",
        "Confidential, fast & professional service",
      ],
    },
    eservices: {
      title: "E-Services",
      body: "All Saudi digital-government platforms — one place.",
      items: [
        "Real Estate Registration (RER)",
        "Najiz platform services",
        "Car insurance",
        "Car ownership transfer",
        "Electricity company transactions",
        "Water company transactions",
        "All government certificates",
        "Opening government files",
        "Data updates",
        "Issuing electronic documents / certificates",
        "Tracking requests across platforms",
        "Services on various government platforms",
      ],
    },
    licensing: {
      title: "Establishment & Licensing",
      body: "From idea to launch — we set up your legal and administrative backbone.",
      items: [
        "Sole proprietorship setup",
        "Establishment-to-company conversion",
        "Commercial register extraction",
        "Contract authentication",
        "Legal file preparation",
        "Systematic business start",
      ],
    },
    foreign: {
      eyebrow: "Foreign Investment",
      title: "Your gateway to the Saudi economy.",
      body: "A full-stack package for foreign investors: license, incorporation, commercial register, and general manager visa.",
      why: {
        t: "Why invest in Saudi Arabia?",
        points: [
          "Among the world’s top-20 economies.",
          "Vision 2030 with unmatched investment incentives.",
          "Sectors open to 100% foreign ownership.",
          "Advanced infrastructure and strategic location.",
        ],
      },
      offering: {
        t: "What we deliver for foreign investors",
        items: [
          "Foreign investment license issuance",
          "Company articles authentication",
          "Commercial register extraction",
          "Government file preparation",
          "General manager visa issuance",
          "Bylaws & administrative structure setup",
        ],
      },
      steps: {
        t: "Licensing steps",
        items: [
          { n: "01", t: "Consultation", d: "Discovery session and activity scoping." },
          { n: "02", t: "Documents", d: "Preparation and legal translation." },
          { n: "03", t: "Submission", d: "Application to the Ministry of Investment." },
          { n: "04", t: "License", d: "License and commercial register issuance." },
          { n: "05", t: "Operations", d: "Visas, files, and business start." },
        ],
      },
      docs: {
        t: "Required documents",
        items: [
          "Parent company’s attested commercial register.",
          "Latest attested financial statements.",
          "Board resolution to invest in Saudi Arabia.",
          "Passports of directors and shareholders.",
          "Legal power of attorney to our office.",
        ],
      },
      duration: {
        t: "Expected duration",
        d: "Typically 5 to 15 working days depending on activity and license type.",
      },
      faq: {
        t: "Frequently asked",
        items: [
          { q: "Can I own 100%?", a: "Yes. Most activities allow full foreign ownership." },
          { q: "Do I need to be present in person?", a: "No. The entire process can be handled by a legal power of attorney." },
          { q: "How much does licensing cost?", a: "It depends on activity and capital. We share a detailed quote after the consultation." },
          { q: "Does it include the GM visa?", a: "Yes. General manager visa is included in the package." },
        ],
      },
      cta: "Start now — request a consultation",
    },
    contact: {
      eyebrow: "Contact",
      title: "Let’s start. Write to us.",
      body: "A fast service-request form. We reply within minutes.",
      form: {
        name: "Full name",
        phone: "Mobile number",
        email: "Email (optional)",
        service: "Service needed",
        message: "Request details",
        submit: "Send request",
        selectService: "Pick a service",
        success: "Your request has been sent. We’ll get back to you shortly.",
        error: "Something went wrong. Try again.",
      },
      channels: {
        phone: "Phone",
        whatsapp: "WhatsApp",
        email: "Email",
      },
    },
    footer: {
      about: "Smart Way International — government follow-up, incorporation and foreign investment services.",
      quickLinks: "Quick links",
      contact: "Contact",
      rights: "All design rights reserved to Adasat Al Fann 2026",
      allRights: "All rights reserved",
    },
    admin: {
      title: "Requests Dashboard",
      tokenLabel: "Admin token",
      login: "Sign in",
      empty: "No requests yet.",
      status: { new: "New", in_progress: "In progress", done: "Done", archived: "Archived" },
      logout: "Sign out",
    },
  },

  ur: {
    dir: "rtl",
    langLabel: "اردو",
    nav: {
      home: "صفحہ اول",
      about: "ہمارے بارے میں",
      services: "خدمات",
      individual: "افراد کی خدمات",
      company: "کمپنیوں کی خدمات",
      followup: "تعقیب خدمات",
      eservices: "الیکٹرانک خدمات",
      foreign: "غیر ملکی سرمایہ کاری",
      licensing: "قیام و لائسنس",
      contact: "رابطہ",
      requestService: "خدمت طلب کریں",
    },
    brand: {
      name: "سمارٹ وے انٹرنیشنل",
      tag: "حکومتی تعقیب، کمپنی رجسٹریشن اور غیر ملکی سرمایہ کاری",
    },
    home: {
      chapter: "باب",
      hero: {
        line1: "کاموں کو مکمل کرنے کا",
        line2: "ذہین راستہ",
        line3: "رفتار، درستگی اور رازداری کے ساتھ۔",
        sub: "سعودی عرب میں حکومتی تعقیب، کمپنی رجسٹریشن اور غیر ملکی سرمایہ کاری کی خصوصی خدمات۔",
        cta1: "خدمت طلب کریں",
        cta2: "واٹس ایپ",
        cta3: "کال کریں",
      },
      intro: {
        eyebrow: "۰۱ — ہم کون ہیں",
        title: "ہم شاہین کی نظر سے کام کرتے ہیں",
        body: "ہم اپنے گاہکوں کو سعودی حکومتی اور انتظامی طریقہ کار میں پوری درستگی، رازداری اور تیزی سے رہنمائی فراہم کرتے ہیں۔",
      },
      services: {
        eyebrow: "۰۲ — ہم کیا کرتے ہیں",
        title: "چار ستون۔ لامحدود امکانات۔",
        cards: [
          { t: "افراد کی خدمات", d: "ابشر، اقامہ، ویزے، کفالت اور دیگر۔", to: "/services/individual" },
          { t: "کمپنیوں کی خدمات", d: "قوی، بلدی، اجرت تحفظ، انسانی وسائل۔", to: "/services/company" },
          { t: "تعقیب خدمات", d: "آپ کی جگہ حکومتی معاملات کی تکمیل۔", to: "/services/follow-up" },
          { t: "غیر ملکی سرمایہ کاری", d: "لائسنس، کمرشل رجسٹر، مینیجر ویزا۔", to: "/services/foreign-investment" },
        ],
      },
      popular: {
        eyebrow: "۰۳ — سب سے مقبول",
        title: "وہ خدمات جن پر ہمارے گاہک بھروسہ کرتے ہیں",
        list: [
          "کفالت کی منتقلی",
          "ویزے کا اجرا",
          "قوی اور اجرت تحفظ",
          "ناجز اور جائیداد رجسٹریشن",
          "غیر ملکی سرمایہ کاری لائسنس",
          "کمپنی رجسٹریشن",
        ],
      },
      why: {
        eyebrow: "۰۴ — ہم کیوں",
        title: "ہم مختلف معیار پر کام کرتے ہیں",
        points: [
          { n: "01", t: "رفتار", d: "کوالٹی سے سمجھوتہ کیے بغیر تیز ٹرن اراؤنڈ۔" },
          { n: "02", t: "رازداری", d: "سخت رازداری کے تحت آپ کے معاملات۔" },
          { n: "03", t: "درستگی", d: "ہر دستاویز پر انسانی نظرثانی۔" },
          { n: "04", t: "فالو اپ", d: "مکمل ہونے تک لائیو اپڈیٹس۔" },
        ],
      },
      stats: {
        eyebrow: "۰۵ — بولتے اعداد",
        items: [
          { n: "+۲۵۰۰", l: "مکمل کیس" },
          { n: "+۴۸۰", l: "بھروسہ کرنے والے کلائنٹس" },
          { n: "۹۸٪", l: "کامیابی کی شرح" },
          { n: "۲۴/۷", l: "مسلسل معاونت" },
        ],
      },
      quickContact: {
        title: "ایک پیغام کی دوری پر",
        sub: "ہم چند منٹوں میں جواب دیتے ہیں:",
      },
      marquee: "تعقیب · سرمایہ کاری · قوی · بلدی · ناجز · GOSI · تجارت · جائیداد · ویزے · ابشر · ",
    },
    about: {
      eyebrow: "ہمارے بارے میں",
      title: "سعودی ذائقے کی سرمایہ کاری کمپنی۔",
      body: "سمارٹ وے انٹرنیشنل حکومتی تعقیب، کمپنی رجسٹریشن اور غیر ملکی سرمایہ کاری کی خصوصی ایجنسی ہے۔ ہم قانونی، انتظامی اور ریگولیٹری مہارت کو یکجا کر کے افراد، کارپوریٹس اور سرمایہ کاروں کے لیے قابلِ اعتماد نتائج فراہم کرتے ہیں۔",
      years: "سالوں کا تجربہ",
      yearsN: "+10",
      vision: {
        t: "وژن",
        d: "افراد، کمپنیوں اور سرمایہ کاروں کا پہلا ساتھی بننا۔",
      },
      mission: {
        t: "مشن",
        d: "پیشہ ورانہ معیار اور مکمل رازداری کے ساتھ تعقیب و مشاورتی خدمات کی فراہمی۔",
      },
      strengths: [
        { t: "رفتار", d: "منضبط ٹرن اراؤنڈ۔" },
        { t: "رازداری", d: "ڈیٹا کی مکمل حفاظت۔" },
        { t: "درستگی", d: "صفر غلطی کی ذہنیت۔" },
        { t: "فالو اپ", d: "درمیان میں کبھی نہیں چھوڑتے۔" },
      ],
      audiences: {
        t: "ہم کن کے لیے خدمات فراہم کرتے ہیں",
        items: ["افراد", "ادارے اور کمپنیاں", "غیر ملکی سرمایہ کار"],
      },
    },
    services: {
      eyebrow: "خدمات",
      title: "آپ کی ضرورت کے مطابق خدمات۔",
      body: "ایک فرد سے لے کر غیر ملکی سرمایہ کار تک، ہم مکمل سعودی حکومتی اور ڈیجیٹل خدمات کا احاطہ کرتے ہیں۔",
      cards: [
        { t: "افراد کی خدمات", d: "ابشر، اقامہ، ویزے، کفالت، طبی بیمہ۔", to: "/services/individual" },
        { t: "کمپنیوں کی خدمات", d: "قوی، بلدی، اجرت تحفظ، GOSI۔", to: "/services/company" },
        { t: "تعقیب خدمات", d: "آپ کی جگہ حکومتی معاملات۔", to: "/services/follow-up" },
        { t: "غیر ملکی سرمایہ کاری", d: "لائسنس، رجسٹر، معاہدے، ویزے۔", to: "/services/foreign-investment" },
        { t: "الیکٹرانک خدمات", d: "ناجز، جائیداد، بجلی، پانی، گاڑیاں۔", to: "/services/e-services" },
        { t: "قیام و لائسنس", d: "کمپنی رجسٹریشن، تبدیلی، کمرشل رجسٹر۔", to: "/services/licensing" },
      ],
    },
    individual: {
      title: "افراد کی خدمات",
      body: "ذاتی حکومتی معاملات کے لیے براہ راست خدمات۔",
      items: [
        "ابشر خدمات",
        "کارکنوں کی کفالت کی منتقلی",
        "اقامہ پرنٹنگ",
        "ویزے کا اجرا",
        "ہروب کی رپورٹ کا خاتمہ",
        "طبی بیمہ",
      ],
    },
    company: {
      title: "کمپنیوں کی خدمات",
      body: "ہر حکومتی و ڈیجیٹل ضرورت کے لیے آپ کا انتظامی شراکت دار۔",
      items: [
        "انسانی وسائل کی خدمات",
        "قوی خدمات",
        "اجرت تحفظ خدمات",
        "بلدی پلیٹ فارم خدمات",
        "GOSI خدمات",
        "وزارتِ تجارت کی خدمات",
        "کارکنوں کے ساتھ کمرشل رجسٹر کی منتقلی",
        "ادارے کو کمپنی میں تبدیلی",
        "انفرادی کمپنی و سرمایہ کاری کا قیام",
      ],
    },
    followup: {
      title: "تعقیب خدمات",
      body: "ہم آپ کی جگہ کرتے ہیں — پیشہ ورانہ، محفوظ اور تیز۔",
      items: [
        "حکومتی معاملات کی تکمیل اور تعقیب",
        "آپ کی جانب سے طریقہ کار کی تکمیل",
        "درخواستیں جمع کرانا اور ٹریک کرنا",
        "سرکاری اداروں کے دورے",
        "دستاویزات اور اجازت نامے کی ترتیب",
        "خفیہ، تیز اور پیشہ ورانہ خدمت",
      ],
    },
    eservices: {
      title: "الیکٹرانک خدمات",
      body: "تمام سعودی ڈیجیٹل حکومتی پلیٹ فارم — ایک جگہ۔",
      items: [
        "جائیداد کی حقیقی رجسٹریشن",
        "ناجز پلیٹ فارم خدمات",
        "گاڑی کا بیمہ",
        "گاڑی کی منتقلی",
        "بجلی کمپنی کے تمام معاملات",
        "پانی کمپنی کے تمام معاملات",
        "تمام سرکاری سرٹیفکیٹ",
        "سرکاری فائلیں کھولنا",
        "ڈیٹا اپڈیٹ",
        "الیکٹرانک دستاویزات کا اجرا",
        "پلیٹ فارم پر درخواستوں کی پیروی",
        "مختلف سرکاری پلیٹ فارمز کی خدمات",
      ],
    },
    licensing: {
      title: "قیام و لائسنس",
      body: "خیال سے آغاز تک — ہم آپ کا قانونی و انتظامی ڈھانچہ ترتیب دیتے ہیں۔",
      items: [
        "انفرادی کمپنی کا قیام",
        "ادارے کو کمپنی میں تبدیلی",
        "کمرشل رجسٹر کا حصول",
        "معاہدہ کی تصدیق",
        "قانونی فائلوں کی تیاری",
        "قانونی طور پر کاروبار کا آغاز",
      ],
    },
    foreign: {
      eyebrow: "غیر ملکی سرمایہ کاری",
      title: "سعودی معیشت کا آپ کا دروازہ۔",
      body: "غیر ملکی سرمایہ کاروں کے لیے مکمل پیکج: لائسنس، قیام، کمرشل رجسٹر، اور جنرل مینیجر ویزا۔",
      why: {
        t: "سعودی عرب میں سرمایہ کاری کیوں؟",
        points: [
          "دنیا کی ٹاپ 20 معیشتوں میں شامل۔",
          "وژن 2030 اور بے مثال ترغیبات۔",
          "100% غیر ملکی ملکیت کی اجازت والے شعبے۔",
          "جدید بنیادی ڈھانچہ اور اسٹریٹجک مقام۔",
        ],
      },
      offering: {
        t: "ہم غیر ملکی سرمایہ کار کو کیا فراہم کرتے ہیں",
        items: [
          "غیر ملکی سرمایہ کاری لائسنس کا اجرا",
          "کمپنی کے قیام کے معاہدے کی تصدیق",
          "کمرشل رجسٹر کا حصول",
          "سرکاری فائلوں کی تیاری",
          "جنرل مینیجر ویزا کا اجرا",
          "بنیادی ضابطہ و انتظامی ڈھانچہ",
        ],
      },
      steps: {
        t: "لائسنس جاری کرنے کے مراحل",
        items: [
          { n: "01", t: "مشاورت", d: "تعارفی سیشن اور سرگرمی کی وضاحت۔" },
          { n: "02", t: "دستاویزات", d: "تیاری اور قانونی ترجمہ۔" },
          { n: "03", t: "درخواست", d: "وزارتِ سرمایہ کاری کو درخواست۔" },
          { n: "04", t: "لائسنس", d: "لائسنس اور کمرشل رجسٹر کی وصولی۔" },
          { n: "05", t: "آپریشنز", d: "ویزے، فائلیں اور کاروبار کا آغاز۔" },
        ],
      },
      docs: {
        t: "درکار دستاویزات",
        items: [
          "پیرنٹ کمپنی کا مصدقہ کمرشل رجسٹر۔",
          "گزشتہ سال کے مصدقہ مالی گوشوارے۔",
          "بورڈ آف ڈائریکٹرز کی سرمایہ کاری قرارداد۔",
          "ڈائریکٹرز اور شیئر ہولڈرز کے پاسپورٹ۔",
          "آفس کے لیے قانونی وکالت۔",
        ],
      },
      duration: {
        t: "متوقع دورانیہ",
        d: "عام طور پر 5 سے 15 کاروباری دن، سرگرمی اور لائسنس کی نوعیت پر منحصر۔",
      },
      faq: {
        t: "اکثر پوچھے گئے سوالات",
        items: [
          { q: "کیا میں 100% مالک ہو سکتا ہوں؟", a: "ہاں، زیادہ تر سرگرمیوں میں مکمل غیر ملکی ملکیت کی اجازت ہے۔" },
          { q: "کیا ذاتی حاضری ضروری ہے؟", a: "نہیں۔ پورا عمل قانونی وکالت کے ذریعے مکمل ہو سکتا ہے۔" },
          { q: "لائسنس کی قیمت کتنی ہے؟", a: "سرگرمی اور سرمائے پر منحصر؛ مشاورت کے بعد تفصیلی قیمت شیئر کرتے ہیں۔" },
          { q: "کیا اس میں GM ویزا شامل ہے؟", a: "جی ہاں، پیکج میں GM ویزا شامل ہے۔" },
        ],
      },
      cta: "ابھی شروع کریں — مشاورت طلب کریں",
    },
    contact: {
      eyebrow: "رابطہ",
      title: "چلیں شروع کرتے ہیں۔",
      body: "تیز خدمت کی درخواست کا فارم۔ ہم چند منٹوں میں جواب دیتے ہیں۔",
      form: {
        name: "پورا نام",
        phone: "موبائل نمبر",
        email: "ای میل (اختیاری)",
        service: "درکار خدمت",
        message: "درخواست کی تفصیل",
        submit: "درخواست بھیجیں",
        selectService: "خدمت منتخب کریں",
        success: "آپ کی درخواست بھیج دی گئی۔ ہم جلد رابطہ کریں گے۔",
        error: "کچھ غلط ہو گیا۔ دوبارہ کوشش کریں۔",
      },
      channels: {
        phone: "فون",
        whatsapp: "واٹس ایپ",
        email: "ای میل",
      },
    },
    footer: {
      about: "سمارٹ وے انٹرنیشنل — حکومتی تعقیب، کمپنی رجسٹریشن اور غیر ملکی سرمایہ کاری۔",
      quickLinks: "فوری روابط",
      contact: "رابطہ",
      rights: "تمام ڈیزائن حقوق عدسة الفن 2026 کے لیے محفوظ",
      allRights: "جملہ حقوق محفوظ",
    },
    admin: {
      title: "درخواستوں کا ڈیش بورڈ",
      tokenLabel: "ایڈمن ٹوکن",
      login: "لاگ ان",
      empty: "ابھی کوئی درخواست نہیں۔",
      status: { new: "نئی", in_progress: "جاری", done: "مکمل", archived: "آرکائیو" },
      logout: "لاگ آؤٹ",
    },
  },
};
